import {
post, put, remove, get,
} from '../../services/api.service';

const state = {
  vouchersTypesList: [],
  headers: [
    {
      text: 'Nazwa',
      value: 'type',
      align: 'center',
    },
    {
      text: 'Data dodania',
      value: 'created_at',
      align: 'center',
    },
    {
      text: 'Akcje',
      sortable: false,
      align: 'center',
      value: 'action',
    },
  ],

};

const mutations = {
  setVouchersTypes(data, payload) {
    data.vouchersTypesList = payload;
  },
};

const getters = {
  getVouchersTypeList: data => data.vouchersTypesList,
  getHeaders: data => data.headers,
};

const actions = {
  fetchVoucherTypes(context) {
    return new Promise((resolve) => {
      get('/voucher_type')
        .then((response) => {
          context.commit('setVouchersTypes', response);
          resolve();
        });
    });
  },
  addVoucherType(context, payload) {
    return new Promise((resolve, reject) => {
      post('/voucher_type', payload)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  editVoucherType(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/voucher_type/${payload.id}`, payload.formData)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  removeVoucherType(context, payload) {
    return new Promise((resolve) => {
      remove(`/voucher_type/${payload}`)
        .then(() => {
          context.dispatch('fetchVoucherTypes');
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
